export default "__VITE_ASSET__Dkzy2L_S__"